import API from "../../services/api";

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function downloadAttendanceTemplate(type, { filled = false } = {}) {
  const path =
    type === "monthly"
      ? `/attendance/upload/templates/monthly?filled=${filled}`
      : `/attendance/upload/templates/daily?filled=${filled}`;
  const res = await API.get(path, { responseType: "blob" });
  const name =
    type === "monthly"
      ? filled
        ? "attendance_monthly_example.xlsx"
        : "attendance_monthly_template.xlsx"
      : filled
        ? "attendance_daily_example.xlsx"
        : "attendance_daily_template.xlsx";
  downloadBlob(res.data, name);
}

export async function previewAttendanceUpload(file, options = {}) {
  const form = new FormData();
  form.append("file", file);
  form.append("upload_type", options.upload_type || "auto");
  form.append("import_mode", options.import_mode || "replace");
  form.append("attendance_source", options.attendance_source || "excel_upload");
  if (options.year != null) form.append("year", String(options.year));
  if (options.month != null) form.append("month", String(options.month));
  const res = await API.post("/attendance/upload/preview", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function importAttendanceUpload(file, options = {}) {
  const form = new FormData();
  form.append("file", file);
  form.append("upload_type", options.upload_type || "auto");
  form.append("import_mode", options.import_mode || "replace");
  form.append("attendance_source", options.attendance_source || "excel_upload");
  if (options.provider_hint) form.append("provider_hint", options.provider_hint);
  if (options.year != null) form.append("year", String(options.year));
  if (options.month != null) form.append("month", String(options.month));
  const res = await API.post("/attendance/upload/import", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function fetchAttendanceUploadBatches(limit = 10) {
  const res = await API.get("/attendance/upload/batches", { params: { limit } });
  return res.data;
}

export async function deleteAttendanceUploadBatch(batchId) {
  const res = await API.delete(`/attendance/upload/batches/${batchId}`);
  return res.data;
}

export async function downloadAttendanceErrorReport(batchId) {
  const res = await API.get(`/attendance/upload/batches/${batchId}/error-report`, {
    responseType: "blob",
  });
  downloadBlob(res.data, `attendance_errors_${batchId}.xlsx`);
}
